// @ts-nocheck
export default function shopifyBtn({ id, variantId, node, text, locale, afterRenderCallback, afterCartRenderCallback, bundleList, shopifyBtnProps = null }) {
    (function () {
        const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
        const styleConfig = {
            us: {
                button: {
                    width: '180px',
                    height: '56px',
                    padding: '12px 0',
                    'margin-top': '-20px',
                    'border-radius': '10px',
                    'background-color': '#165dff',
                    'font-size': '17px',
                    // 'font-family': 'Manrope-SemiBold',
                    ':hover': {
                        'background-color': '#165dff',
                    },
                    ':focus': {
                        'background-color': '#165dff',
                    },
                },
            },
            jp: {
                button: {
                    width: '100%',
                    height: '56px',
                    padding: '12px 0',
                    'margin-top': '-20px',
                    'border-radius': '10px',
                    'background-color': '#165dff',
                    'font-size': '17px',
                    // 'font-family': 'Manrope-SemiBold',
                    ':hover': {
                        'background-color': '#165dff',
                    },
                    ':focus': {
                        'background-color': '#165dff',
                    },
                },
            },
        };
        if (window.ShopifyBuy) {
            if (window.ShopifyBuy.UI) {
                ShopifyBuyInit();
            } else {
                loadScript();
            }
        } else {
            loadScript();
        }
        function loadScript() {
            const script = document.createElement('script');
            script.async = true;
            script.src = scriptURL;
            (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
            script.onload = function () {
                ShopifyBuyInit();
            };
        }
        function ShopifyBuyInit() {
            const options = {
                us: {
                    domain: 'us.ecoflow.com',
                    // domain: 'ecoflow-tech.myshopify.com',
                    storefrontAccessToken: '53235765553831c6dfca54cac05e9d9e',
                },
                jp: {
                    domain: 'jp.ecoflow.com',
                    storefrontAccessToken: '725fc1c85ba5b3e12e3933afe8c3f32a',
                },
                ca: {
                    domain: 'ca.ecoflow.com',
                    storefrontAccessToken: '0e67d1cc51449b5d6b52925de84167a0',
                },
                // wave2 新增早鸟 20230515
                eu: {
                    domain: 'eu.ecoflow.com',
                    storefrontAccessToken: '8855bd6de50599d2b12808e4497b6881',
                },
                uk: {
                    domain: 'uk.ecoflow.com',
                    storefrontAccessToken: 'a54b21e590894bf994dd1259c060b28c',
                },
                de: {
                    domain: 'de.ecoflow.com',
                    storefrontAccessToken: '0f49db60b0bc8f958f5a6b6a7bd76263',
                },
                fr: {
                    domain: 'fr.ecoflow.com',
                    storefrontAccessToken: '40414a617e9b4a1e524cb040e7d2dd21',
                },
                it: {
                    domain: 'it.ecoflow.com',
                    storefrontAccessToken: '6622d0e63079813fe8bbe28a7f54a249',
                },
                es: {
                    domain: 'es.ecoflow.com',
                    storefrontAccessToken: '9e7e2f15857abb92731cd753ffdb671b',
                },
            };
            const moneyFormats = {
                us: '%24%7B%7Bamount%7D%7D',
                jp: '%C2%A5%7B%7Bamount_no_decimals%7D%7D',
                // wave2 新增早鸟 20230515
                eu: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
                uk: '%C2%A3%7B%7Bamount%7D%7D',
                de: '%7B%7Bamount_with_comma_separator%7D%7D%20%E2%82%AC',
                fr: '%7B%7Bamount_with_comma_separator%7D%7D%E2%82%AC',
                it: '%7B%7Bamount_with_comma_separator%7D%7D%E2%82%AC',
                es: '%7B%7Bamount_with_comma_separator%7D%7D%20%E2%82%AC',
            };
            const cartText = {
                us: {},
                jp: {
                    title: 'ショッピングカート',
                    total: '合計(税込)',
                    empty: 'お客様のショッピングバッグに商品はありません。',
                    notice: '送料無料',
                    button: '注文手続きへ',
                },
            };
            const client = ShopifyBuy.buildClient(shopifyBtnProps?.options || options[locale] || options['us']);
            ShopifyBuy.UI.onReady(client).then(function (ui) {
                const target = document.getElementById(node);
                if (target) {
                    ui.createComponent('product', {
                        id,
                        variantId,
                        node: document.getElementById(node),
                        moneyFormat: moneyFormats[locale] || moneyFormats['us'],
                        options: {
                            product: {
                                text: {
                                    button: text.buy || 'Buy now',
                                    outOfStock: text.soldout || 'Sold out',
                                },
                                contents: {
                                    img: false,
                                    title: false,
                                    button: true,
                                    price: false,
                                    options: false,
                                },
                                styles: {
                                    button: styleConfig[locale]?.button || styleConfig['us'].button,
                                },
                                events: {
                                    afterRender: function (component) {
                                        afterRenderCallback && afterRenderCallback();
                                    },
                                },
                            },
                            modalProduct: {
                                contents: {
                                    img: false,
                                    imgWithCarousel: true,
                                    button: false,
                                    buttonWithQuantity: true,
                                },
                                styles: {
                                    product: {
                                        '@media (min-width: 601px)': {
                                            'max-width': '100%',
                                            'margin-left': '0px',
                                            'margin-bottom': '0px',
                                        },
                                    },
                                    button: {
                                        ':hover': {
                                            'background-color': '#1447b2',
                                        },
                                        'background-color': '#164fc6',
                                        ':focus': {
                                            'background-color': '#1447b2',
                                        },
                                        'border-radius': '21px',
                                    },
                                },
                                text: {
                                    button: 'Add to cart',
                                },
                            },
                            option: {},
                            cart: {
                                text: shopifyBtnProps?.cartText || cartText[locale] || cartText['us'],
                                styles: {
                                    button: {
                                        ':hover': {
                                            'background-color': '#1447b2',
                                        },
                                        'background-color': '#164fc6',
                                        ':focus': {
                                            'background-color': '#1447b2',
                                        },
                                        'border-radius': '21px',
                                    },
                                    // 测试一定要求修改close的样式
                                    header: {
                                        close: {
                                            'font-size': '30px',
                                            ':focus-visible': {
                                                outline: 'none',
                                            },
                                        },
                                    },
                                    cartScroll: {
                                        lineItems: {
                                            lineItem: {
                                                quantity: {
                                                    height: '30px',
                                                    'line-height': '30px',
                                                },
                                            },
                                        },
                                    },
                                },
                                events: {
                                    afterRender: function (component) {
                                        afterCartRenderCallback && afterCartRenderCallback(bundleList);
                                    },
                                },
                            },
                            toggle: {
                                styles: {
                                    toggle: {
                                        'background-color': '#164fc6',
                                        ':hover': {
                                            'background-color': '#1447b2',
                                        },
                                        ':focus': {
                                            'background-color': '#1447b2',
                                        },
                                    },
                                },
                            },
                        },
                    });
                }
            });
        }
    })();
}

export const formatFlow = (val: string) => {
    return (val || '0').toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
};
